import * as Period from 'constants/Period';

const FOOTBALL_PERIOD_MAP = {};
FOOTBALL_PERIOD_MAP[700] = Period.NOT_STARTED;
FOOTBALL_PERIOD_MAP[701] = Period.FIRST;
FOOTBALL_PERIOD_MAP[702] = Period.FIRST_BREAK;
FOOTBALL_PERIOD_MAP[703] = Period.SECOND;
FOOTBALL_PERIOD_MAP[704] = Period.FULL_TIME;
FOOTBALL_PERIOD_MAP[705] = Period.FIRST_EXTRA;
FOOTBALL_PERIOD_MAP[706] = Period.FIRST_EXTRA_BREAK;
FOOTBALL_PERIOD_MAP[707] = Period.SECOND_EXTRA;
FOOTBALL_PERIOD_MAP[708] = Period.SECOND_EXTRA_BREAK;
FOOTBALL_PERIOD_MAP[709] = Period.PENALTIES;
FOOTBALL_PERIOD_MAP[710] = Period.FINISHED;

export default FOOTBALL_PERIOD_MAP;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Football/PeriodMap.js